import { city as cityPlat, city } from "ca-plateform-plateform-commons";
import { Severity } from "../../../../components/src/Component/Snackbar";

export const getAlertSeverity = (
  severity: Severity
): city.colisactiv.platform.commons.AlertSeverity => {
  return new cityPlat.colisactiv.platform.commons.AlertSeverity(severity);
};
